import * as Sentry from '@sentry/react'
import type { ConsentState } from './state'

// Idempotent guard — Sentry.addIntegration must only be called once per session.
// Multiple calls register multiple replay integrations, causing duplicate events.
let replayAdded = false

/**
 * Add the Sentry Replay integration lazily, respecting consent.
 *
 * Consent logic:
 * - Outside the consent region (EEA/UK/CH): replay starts unconditionally —
 *   no ePrivacy obligation applies.
 * - Inside the consent region: only start if the user explicitly opted in
 *   (consent.replay === true). If consent is null (undecided) or replay=false,
 *   replay stays off — even errors won't attach a replay.
 *
 * Called from App.tsx on every consent/inConsentRegion change. Safe to call
 * multiple times; the `replayAdded` guard makes all subsequent calls no-ops.
 */
export function maybeLoadReplay(
  consent: ConsentState | null,
  inConsentRegion: boolean,
): void {
  if (replayAdded) return

  if (!inConsentRegion || consent?.replay === true) {
    Sentry.addIntegration(
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    )
    replayAdded = true
  }
}
